import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import Component from '../components/summary.step.jsx'
import actions from '../actions/summary'
import cardActions from '../actions/paymentMethod'
import startActions from '../actions/start'

class Container extends React.Component {

  constructor(props) {
    super(props)

    props.getCards()
  }

  confirm = () => {
    if (this.props.willReturnItems === true) {
      this.props.modifyAndConfirmRent()
        .then(success => {
          if (success) this.props.requestNextStep()
        })
    } else {
      this.props.modifyAndConfirmReturn()
        .then(success => {
          if (success) this.props.requestNextStep()
        })
    }
  }

  goToPayment = () => {
    this.props.requestSpecificStep('payment', 'summary', 'summary')
  }

  render() {
    return <Component {...this.props} confirm={this.confirm} goToPayment={this.goToPayment}/>
  }

  static propTypes = {
    getCards: PropTypes.func.isRequired,
    requestSpecificStep: PropTypes.func.isRequired,
    willReturnItems: PropTypes.bool.isRequired,
    modifyAndConfirmRent: PropTypes.func.isRequired,
    modifyAndConfirmReturn: PropTypes.func.isRequired,
    requestNextStep: PropTypes.func.isRequired,
  }
}

const mapStateToProps = state => {
  const data = state.ui.remove.summary
  const startData = state.ui.remove.start
  const timeSlotStart = data.get('timeslotsStart').toArray().find(t => t.ID === data.get('timeslotStart'))
  const timeSlotEnd = data.get('timeslotsEnd').toArray().find(t => t.ID === data.get('timeslotEnd'))
  return {
    items: startData.get('items').toArray(),
    willReturnItems: startData.get('willReturnItems'),
    address: data.get('addresses').toArray().find(a => a.ID === data.get('address')),
    dateStart: data.get('dateStart') ? data.get('dateStart').hour(timeSlotStart ? timeSlotStart.Hour : 0).minute(timeSlotStart ? timeSlotStart.Minute : 0) : null,
    dateEnd: data.get('dateEnd') === null ? null : data.get('dateEnd').hour(timeSlotEnd ? timeSlotEnd.Hour : 0).minute(timeSlotEnd ? timeSlotEnd.Minute : 0),
    cards: data.get('cards').toArray(),
    card: data.get('cards').toArray().find(c => c.ID === data.get('card')),
    rentPrice: data.get('rentPrice'),
    deliveryCost: data.get('deliveryCost'),
    pickupCost: data.get('pickupCost'),
    comment: data.get('comment'),
    isConfirming: data.get('isConfirming'),
    error: data.get('error'),
    requireCardForDeposit: data.get('requireCardForDeposit'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setComment: value => dispatch(actions.setComment(value)),
    getCards: () => dispatch(cardActions.fetch()),
    selectCard: (card) => dispatch(actions.selectCard(card)),
    modifyAndConfirmRent: () => dispatch(startActions.modifyAndConfirmRent()),
    modifyAndConfirmReturn: () => dispatch(startActions.modifyAndConfirmReturn()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)



// WEBPACK FOOTER //
// ./src/sections/remove/containers/summary.js